import axios from "axios";
import qs from "qs";
// import { getToken } from '@/utils/auth';
import { assignParams, urlEncode } from "@/until/common";
import crypto from "@/until/encode";
import { xzLocal } from "@/until/common";
import store from "@/store";
import { config, getServerUrls } from "./config";

let serverList = []; // 全局服务器列表
let refreshInterval = null; // 定时器句柄

// 缓存服务器列表到 Vuex 和 localStorage
const cacheServerList = (servers) => {
  serverList = servers;
  store.commit("server/SET_SERVER_LIST", servers); // 缓存到 Vuex
  localStorage.setItem("serverList", JSON.stringify(servers)); // 缓存到 localStorage
};

// 从缓存加载服务器列表
export const loadCachedServerList = () => {
  const cachedServers = localStorage.getItem("serverList");
  if (cachedServers) {
    const servers = JSON.parse(cachedServers);
    serverList = servers;
    store.commit("server/SET_SERVER_LIST", servers);
    return servers;
  }
  return [];
};

// 计算单个服务器的延迟
const calculatePing = async (server) => {
  try {
    const startTime = Date.now();
    // console.log("server.url", server.url);
    // console.log(`${server.url}/user/v2/api/common/TestTime`);
    await axios.get(`${server.url}/user/v2/api/common/TestTime`, { timeout: 3000 });
    server.latency = Date.now() - startTime;
    server.timeout = false;
  } catch (error) {
    server.latency = "超时";
    server.timeout = true;
  }
};

// 遍历所有服务器计算延迟
const calculateAllServersPing = async () => {
  await Promise.all(
    serverList.map(async (server) => {
      await calculatePing(server);
    })
  );
  store.commit("server/SET_SERVER_LIST", serverList); // 更新到 Vuex
};

// 获取服务器列表（第一步：从OSS获取交易商列表）
export const fetchServerList = async () => {
  try {
    // 第一步：获取主服务器列表，只取第一条
    // !!!  (后续通过比对当前域名和服务器列表的域名来取，DDT目前只取第一条） !!!
    const response = await axios.get(config.serviceListUrl);
    const resStr = crypto.decode(response.data); // 解密数据
    const serviceList = JSON.parse(resStr); // 转换为对象

    if (serviceList.length === 0) {
      throw new Error("主服务器列表为空");
    }

    const firstService = serviceList[0]; // 只取第一条
    // console.log("第一步获取的主服务器：", firstService);

    // 第二步：根据第一条数据的ServiceCode获取具体的服务器信息
    const serverResponse = await axios.get(config.serviceCodeUrl(firstService.ServiceCode));
    const serverResStr = crypto.decode(serverResponse.data); // 解密
    const serverData = JSON.parse(serverResStr); // 转换为对象

    // console.log("第二步获取的服务器信息：", serverData);

    if (serverData.length === 0) {
      throw new Error("服务器列表为空");
    }

    // 遍历所有的服务器信息
    const servers = serverData.map((server) => ({
      name: server.Name,
      url: `https://api.${server.Domain}`, // 从解密后的数据中获取域名
      latency: null,
      timeout: false,
    }));

    cacheServerList(servers); // 缓存服务器列表
    startLatencyRefresh(); // 启动延迟刷新
    return servers;
  } catch (error) {
    console.error("获取服务器列表失败:", error);
    return [];
  }
};

// 获取当前选中的服务器
export const getSelectedServer = () => {
  const storedServer = store.getters["server/getSelectedServer"];
  if (storedServer && storedServer.name) {
    return storedServer;
  }
  const cachedServer = localStorage.getItem("selectedServer");
  return cachedServer ? JSON.parse(cachedServer) : null;
};

// 设置当前选中的服务器
export const setSelectedServer = (server) => {
  store.commit("server/SET_SELECTED_SERVER", server);
  localStorage.setItem("selectedServer", JSON.stringify(server));
  window.location.reload();
};

// 同步获取服务器列表
export const getServerListSync = () => {
  if (serverList.length === 0) {
    console.warn("Server list is empty. Ensure fetchServerList is called first.");
  }
  return serverList;
};

// 启动定时器每3秒刷新延迟数据
const startLatencyRefresh = () => {
  if (refreshInterval) clearInterval(refreshInterval); // 确保只启动一个定时器
  refreshInterval = setInterval(async () => {
    // console.log("刷新延时数据...");
    await calculateAllServersPing(); // 刷新延迟
  }, 3000);
};

// 停止定时刷新
const stopLatencyRefresh = () => {
  if (refreshInterval) {
    clearInterval(refreshInterval);
    refreshInterval = null;
  }
};

// 停止所有相关任务
export const stopAllTasks = () => {
  stopLatencyRefresh();
};


class Server {
  constructor(baseUrlFn, type) {
    if (!baseUrlFn) {
      return;
    }
    this.getBaseUrl = baseUrlFn;
    this.type = type;
    this.instance = axios.create({
      baseURL: this.getBaseUrl(),
      timeout: config.timeout,
      headers: {
        "content-Type": "application/json",
      },
    });
    this.instance.interceptors.response.use(
      (response) => {
        let responseData = response.data;
        // 服务错误
        if (/error/.test(responseData))
          return Promise.reject(new Error({ message: "服务器开小差！！" }));
        // userToken 失效
        if (responseData.Status === 10003) {
          window.location.href = "#/login";
        }
        // 当返回数据为加密数据时
        if (typeof responseData !== "object") {
          try {
            const resStr = crypto.decode(responseData);
            responseData = JSON.parse(resStr);
            console.log("responseData", responseData)
          } catch (error) {
            console.error("解密失败", error);
          }
        }
        if (responseData.status != 1) {
          // ElMessage({
          //     message: responseData.message,
          //     type: 'error',
          // });
          // Toast({ title: responseData.message, type: 'error' });
        }
        return responseData;
      },
      (error) => {
        if (error && error.response) {
          // eslint-disable-next-line no-param-reassign
          error.message =
            config.RESPONSE_CODE[error.response.status] || "服务器开小差！！";
        }
        return Promise.reject(error);
      }
    );
    this.instance.interceptors.request.use(
      (baseConfig) => {
        const dynamicBaseUrl = this.getBaseUrl(); // 动态设置 baseURL
        baseConfig.baseURL = dynamicBaseUrl;

        let isEncode = false;
        if (baseConfig.data && baseConfig.data.isJson) {
          if (baseConfig.data.isJson === 1) {
            baseConfig.data.isJson = null;
            Object.assign(baseConfig.headers, {
              "Content-Type": "application/json",
            });
            delete baseConfig.data.isJson;
          }
        } else {
          if (baseConfig.method === "post" || baseConfig.method === "patch") {
            isEncode = Boolean(baseConfig.data.encode);
            delete baseConfig.data.encode;

            Object.assign(baseConfig.headers, {
              "Content-Type": "application/x-www-form-urlencoded",
            });

            if (isEncode) {
              const param = crypto.encode(urlEncode(baseConfig.data));
              baseConfig.data = qs.stringify({ param });
            } else {
              baseConfig.data = qs.stringify(baseConfig.data);
            }
          }
        }

        return baseConfig;
      },
      (err) => {
        console.error("网络异常：", err);
      }
    );
  }

  get = (url, params) => {
    const userToken = xzLocal.get("userToken")
      ? xzLocal.get("userToken")
      : null;
    const lang = store.getters.getNowTheme.lang;
    const cpParams = userToken
      ? assignParams(Object.assign(params, { userToken, lang }))
      : assignParams(Object.assign(params, { lang }));
    return this.instance.get(url, { params: cpParams });
  };

  post = (url, params = {}, encode) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get("userToken")
      ? xzLocal.get("userToken")
      : null;
    const cpParams = userToken
      ? urlEncode(assignParams({ userToken, lang }))
      : urlEncode(assignParams({ lang }));
    const data = Object.assign(params, { encode });
    return this.instance.post(`${url}?${cpParams}`, data);
  };

  proxy_post = (url, params = {}) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get("userToken")
      ? xzLocal.get("userToken")
      : null;
    const cpParams = userToken
      ? urlEncode(assignParams({ userToken, lang }))
      : urlEncode(assignParams({ lang }));

    const headers = {
      "Content-Type": "application/json",
    };

    params.isJson = true;

    console.log("params", params);
    return this.instance.post(`${url}?${cpParams}`, params, {
      headers,
    });
  };

  put = (url, params = {}) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get("userToken")
      ? xzLocal.get("userToken")
      : null;
    const cpParams = userToken
      ? urlEncode(assignParams({ userToken, lang }))
      : urlEncode(assignParams(lang));
    return this.instance.put(`${url}?${cpParams}`, params);
  };

  delete = (url, params = {}) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get("userToken")
      ? xzLocal.get("userToken")
      : null;
    const cpParams = userToken
      ? urlEncode(assignParams({ userToken, lang }, params))
      : urlEncode(assignParams(lang));
    return this.instance.delete(`${url}/${params.id}?${cpParams}`);
  };

  patch = (url, params = {}) => {
    const lang = store.getters.getNowTheme.lang;
    const userToken = xzLocal.get("userToken")
      ? xzLocal.get("userToken")
      : null;
    const cpParams = userToken
      ? urlEncode(assignParams({ userToken, lang }))
      : urlEncode(assignParams(lang));
    return this.instance.patch(`${url}?${cpParams}`, params);
  };
}

// user 站点
const http = new Server(() => getServerUrls().http, "http");
const newshttp = new Server(() => getServerUrls().newshttp, "newshttp");
const hqhttp = new Server(() => getServerUrls().hqhttp, "hqhttp");
const payhttp = new Server(() => getServerUrls().payhttp, "payhttp");
const activityhttp = new Server(() => getServerUrls().activityhttp, "activityhttp");
const tradehttp = new Server(() => getServerUrls().tradehttp, "tradehttp");
const paymenthttp = new Server("", payhttp);
const stradehttp = new Server(() => getServerUrls().stradehttp, "stradehttp");
const followorderhttp = new Server(() => getServerUrls().followorderhttp, "followorderhttp");
const proxyhttp = new Server(() => getServerUrls().proxyhttp, "proxyhttp");

export default {
  http,
  newshttp,
  hqhttp,
  payhttp,
  tradehttp,
  paymenthttp,
  activityhttp,
  stradehttp,
  followorderhttp,
  proxyhttp,
  fetchServerList,
  getServerListSync,
  calculatePing,
  setSelectedServer,
  stopAllTasks,
  loadCachedServerList,
};
